import { useEffect, useState } from "react";
import HelTag from "react-helmet";
import Icon from "react-multi-date-picker/components/icon";
import { useSelector } from "react-redux";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import { ReducerType } from "../../../storeManager/ReducerType";
import { RaytebRequests } from "../../../_services";
import useFetch from "../../../_services/fetch";

const BackupRecord = () => {
  const [files, setFiles] = useState<Array<BackupRecordModel>>();
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  );
  const handleClick = (e) => {
    e.preventDefault();
    // Additional logic if needed
  };
  const { isLoading, reFetch } = useFetch<Array<BackupRecordModel>, Object>({
    request: RaytebRequests.Downloads_GetBackupRecord_GET({
      headers: { centerId: center.id },
      token: user?.token,
    }),
    onSuccess(data) {
      setFiles(data);
    },
  });

  useEffect(() => {
    reFetch();
  }, [center]);
  return (
    <>
      <HelTag>
        <title>پرونده</title>
      </HelTag>
      <section className="flex flex-row flex-wrap justify-start h-100 mt-5 text-center">
        {files?.map((n, i) => (
          <>
            <div
              className={`border p-2 rounded-lg m-2 w-36  border-primaryLight  ${n.fileAddress != null
                  ? "bg-white cursor-pointer border-primary"
                  : ""
                }`}
              key={i}
            >
              <div className="border rounded-full w-10 h-10 flex justify-center items-center m-auto">
                {n.fileAddress == null ? (
                  <a
                    className="rayteb-download text-2xl inline text-primaryLight"
                    target="_blank"
                    href="#"
                    onClick={handleClick}
                  ></a>
                ) : (
                  <a
                    className="rayteb-download text-2xl inline"
                    target="_blank"
                    href={`${window.env['APP_Rayteb_Domain']}/cdn/${n.fileAddress}`}
                  ></a>
                )}
              </div>

              <div>
                <div className="text-xs mt-2">
                  <label> تاریخ ثبت: </label>
                  <span>{new Date(n.insertDate).toShamsi()}</span>
                </div>
                <div className="text-xs ">
                  <label>بازه ی </label>
                  <br />
                  <span>
                    {new Date(n.fromDate).toShamsi()} تا{" "}
                    {new Date(n.toDate).toShamsi()}
                  </span>
                </div>
              </div>
            </div>
          </>
        ))}
      </section>
    </>
  );
};

export default BackupRecord;
